import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/agencyPaymentMethod/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/agencyPaymentMethod/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/agencyPaymentMethod/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/agencyPaymentMethod/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/agencyPaymentMethod/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/agencyPaymentMethod/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/agencyPaymentMethod/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/agencyPaymentMethod/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/agencyPaymentMethod/DELETE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createAgencyPaymentMethod(agencyPaymentMethod, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      agency_payment_method: agencyPaymentMethod,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/agency/agency_payment_methods.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENCY_PAYMENT_METHOD)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateAgencyPaymentMethod(agencyPaymentMethod, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      agency_payment_method: agencyPaymentMethod,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/agency/agency_payment_methods/${agencyPaymentMethod.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENCY_PAYMENT_METHOD)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function deleteAgencyPaymentMethod(agencyPaymentMethod, options, callback, errorCallback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const { id } = agencyPaymentMethod
    const promise = api(`/agency/agency_payment_methods/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENCY_PAYMENT_METHOD)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))

        if (errorCallback) errorCallback(errors)

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return { ...state, creating: true  }
    case CREATE_SUCCESS:
      return {
 ...state,
creating: false,
        errors: []  
}
    case CREATE_FAILURE:
      return {
 ...state,
creating: false,
        errors: action.errors  
}
    case UPDATE_REQUEST:
      return { ...state, updating: true  }
    case UPDATE_SUCCESS:
      return {
 ...state,
updating: false,
        errors: []
  }
    case UPDATE_FAILURE:
      return {
 ...state,
updating: false,
        errors: action.errors  
}
    case DELETE_REQUEST:
      return { ...state, deleting: true  }
    case DELETE_SUCCESS:
      return {
 ...state,
deleting: false,
        errors: [] 
 }
    case DELETE_FAILURE:
      return {
 ...state,
deleting: false,
        errors: action.errors 
 }
    default:
      return state
  }
}
